import { atom } from "recoil";


const searchtextAtom = atom({
  key: 'searchtextAtom', 
  default: "", 
 });


 export default searchtextAtom;

